import { MasterDataType } from '../actions/ActionType';

const defaultState = {
  assetsType: [],
  masterDataTags: [],
  tags: [],
  masterDataSupplier: [],
  status: [{label: 'Active', value: 'active'}, {label: 'InActive', value: 'inActive'}],
  contractType:[{label: 'Contract', value: 'contract'}, {label: 'Permanent', value: 'permanent'}],
  FTEType:[{label: 'Full Time', value: 'fullTime'}, {label: 'Part Time', value: 'partTime'}],
  masterDataSupplier: [],
  masterDataUserId: [],
  masterDataOs: [],
  masterDataDMedia: [],
  masterDataFunctionalCategory: [],
  tags: []
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case MasterDataType.GET_MASTERDATA_ASSETS:
      const newState = Object.assign({}, state, { assetsType: action.payload });
      return newState;
    case MasterDataType.GET_MASTERDATA_TAGS:
      const data = Object.assign({}, state, { masterDataTags: action.payload });
      return data;
    case MasterDataType.GET_TAGS:
      const tags = Object.assign({}, state, { tags: action.payload });
      return tags;
    case MasterDataType.GET_MASTERDATA_SUPPLIER:
      const supplierData = Object.assign({}, state, { masterDataSupplier: action.payload });
      return supplierData;
    case MasterDataType.GET_MASTERDATA_USERID:
      const userData = Object.assign({}, state, { masterDataUserId: action.payload });
      return userData;
    case MasterDataType.GET_MASTERDATA_OS:
      const osData = Object.assign({}, state, { masterDataOs: action.payload });
      return osData;
    case MasterDataType.GET_MASTERDATA_DMEDIA:
      const DMData = Object.assign({}, state, { masterDataDMedia: action.payload });
      return DMData;
    case MasterDataType.GET_MASTERDATA_FUNCTIONAL_CATEGORY:
      const fcData = Object.assign({}, state, { masterDataFunctionalCategory: action.payload });
      return fcData;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/MasterDataReducer.js